import { ActionContext, ActionTree } from 'vuex';
import ApiService from '@/modules/ewerp/service/LagerService';

import { S } from '@/modules/ewerp/models/EnergiezahlerModels';

import { RootState } from '@/modules/ewerp/store';
import { useEwerpCommonStore } from '@/modules/ewerp/store/ewerpCommonStore';
import { State } from './state';

import { Mutations, MutationTypes } from './mutations';


export enum ActionTypes {
  GetMaschineLeistung = 'GETMASCHINELEISTUNG',
}

type ActionArguments = Omit<ActionContext<State, RootState>, 'commit'> & {
  commit<K extends keyof Mutations>(key: K, payload: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>;
};

export type Actions = {
  [ActionTypes.GetMaschineLeistung](context: ActionArguments, maschinenr: number): Promise<void>;
};

export const actions: ActionTree<State, RootState> & Actions = {
  async [ActionTypes.GetMaschineLeistung]({ commit }, maschinenr) {
    const commonStore = useEwerpCommonStore();
    const status = commonStore.status;
    status.energiezaehlerLoading = true;
    status.energiezaehlerErrorMsg = '';
    commonStore.setStatus(status);

    return ApiService.getMaschineLeistungWerte(maschinenr)
      .then((res) => {
        const data: S = res.data;
        commit(MutationTypes.AddOrUpdatemaschinenLeistungsWerte, data);
      })
      .catch((err) => {
        // console.log(err.response);

        if (err.response.status == 404) {
          commit(MutationTypes.RemoveMaschinenLeistungsWerte, maschinenr);
        }

        status.energiezaehlerErrorMsg = err.response.data;
        commonStore.setStatus(status);
      })
      .finally(() => {
        status.energiezaehlerLoading = false;
        commonStore.setStatus(status);
      });
  },
};
